import { createSlice } from '@reduxjs/toolkit';

  export const createAnalyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    defaultBasicTag: {},
    submitDataTag:{},
    formDataTag:{}
  },
  reducers: {
    analyticsSubmitDefinition: (state, action) => {
        state.submitDataTag = {...state.submitDataTag, ...action.payload};
    },
    updateDefaultBasicTag: (state, action) => {
        state.defaultBasicTag = {...state.defaultBasicTag, ...action.payload}
    },
    updateFormDataTag: (state, action) => {
      state.formDataTag = { ...state.formDataTag, ...action.payload }
    }
  }
});

export const { updateDefaultBasicTag, analyticsSubmitDefinition, updateFormDataTag } = createAnalyticsSlice.actions;

export default createAnalyticsSlice.reducer;
